import { type IApiMessage } from '@synqo/frontend-component-library';

/**
 * Parses a JSON-serialized `IApiMessage` or `IApiMessage[]` payload (the shape used by
 * backend-pushed notifications), always returning an array.
 */
export function parseApiMessages(payload: string): IApiMessage[] {
    const parsed: IApiMessage | IApiMessage[] = JSON.parse(payload);
    return Array.isArray(parsed) ? parsed : [parsed];
}

/**
 * One message as the single line of prose a person reads, mirroring how the backend writes it into
 * a record's result summary: the title only earns its place when there is one.
 *
 * @ai-generated 2026-08-26T12:58:28+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
 */
export function describeApiMessage(message: IApiMessage): string {
    return message.title ? `${message.title}: ${message.message}` : message.message;
}
